// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import ConditionalRevealController from "./conditional_reveal_controller"
application.register("conditional-reveal", ConditionalRevealController)

import DocxController from "./docx_controller"
application.register("docx", DocxController)

import FlowSourceController from "./flow_source_controller"
application.register("flow-source", FlowSourceController)

import TimelineLinkController from "./timeline_link_controller"
application.register("timeline-link", TimelineLinkController)
